import { FC, useEffect } from 'react'
import { OneOffTimeWindow } from '../../formComponents'

import { ModalSectionProps, RotaPatternModalType } from '../utils'
import { calculateDuration } from 'screens/Rostering/RotaBuilder/common/utils'
import dayjs from 'dayjs'

export const OneOffTimeWindowSection: FC<
  ModalSectionProps & {
    type?: RotaPatternModalType
    shortTitle?: boolean
    disableStartTime?: boolean
    disableEndTime?: boolean
  }
> = ({
  type,
  shortTitle,
  formData,
  form,
  setFormData,
  disableStartTime,
  disableEndTime,
}) => {
  const isFlexiType = formData?.flexiType

  const duration = +calculateDuration(
    dayjs(formData?.patternTimeWindow?.[0]).toDate(),
    dayjs(formData?.patternTimeWindow?.[1]).toDate()
  ).durationInMinutes

  useEffect(() => {
    if (!shortTitle) form?.setFieldValue('plannedDuration', duration)
  }, [isFlexiType])

  const handleStartTimeChanged = (value?: string) => {
    setFormData?.((prev: any) => ({ ...prev, startTime: value }))
    form?.setFieldValue('startTime', value)
  }
  const handleEndTimeChanged = (value?: string) => {
    setFormData?.((prev: any) => ({ ...prev, endTime: value }))
    form?.setFieldValue('endTime', value)
  }

  return (
    <OneOffTimeWindow
      type={type}
      shortTitle={shortTitle}
      isFlexiType={isFlexiType}
      formData={formData}
      onEndTimeChanged={handleEndTimeChanged}
      onStartTimeChanged={handleStartTimeChanged}
      disableStartTime={disableStartTime}
      disableEndTime={disableEndTime}
    />
  )
}
